export class VildData {
  locNr: number;
}



// WEBPACK FOOTER //
// ./src/app/models/vilddata.model.ts